/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileExcel16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M13.25 14a.748.748 0 00.75-.75V2.75a.748.748 0 00-.75-.75H5a.748.748 0 00-.75.75v1.5h-1.5A.748.748 0 002 5v6a.748.748 0 00.75.75h1.5v1.5A.748.748 0 005 14h8.25zm-4.5-9.75H5v-1.5h3.75v1.5zm4.5 0H9.5v-1.5h3.75v1.5zm0 3H9.5V5h3.75v2.25zm-8.344 3.188H3.395l1.582-2.45-1.442-2.426h1.518l.756 1.495.82-1.495h1.43l-1.483 2.42 1.518 2.455H6.6l-.838-1.564-.856 1.565zm8.344-.188H9.5V8h3.75v2.25zm0 3H9.5V11h3.75v2.25zm-4.5 0H5v-1.5h3.75v1.5z"
        />
    </AccessibleSVG>
);

export default FileExcel16;
